import React from "react";
import Link from "next/link";

import Modal from "./modal";
import { Button, P } from "../../ui";
import {
  trackUpgradeCtaClicked,
  plansUrlWithUpgradeSource,
  type LimitType,
} from "../../analytics";

function UpgradeTeamPlanModal({
  toggle,
  isOpen,
  description,
  upgradeSource = "upgrade_plan_modal",
  limitType,
  plan,
}: {
  toggle: () => void;
  isOpen: boolean;
  description: string;
  upgradeSource?: string;
  limitType?: LimitType;
  plan?: string | null;
}) {
  const onViewPlans = () => {
    trackUpgradeCtaClicked({
      source: upgradeSource,
      limit_type: limitType,
      plan,
    });
  };

  return (
    <Modal toggle={toggle} isOpen={isOpen} size="sm:max-w-lg" closeButton>
      <div className="text-left">
        <div className="sm:flex sm:items-start mb-4">
          <h3
            className="text-base font-semibold tracking-tight text-neutral-900"
            id="modal-headline"
          >
            Upgrade Account
          </h3>
        </div>
        <div>
          <P>
            {description}
          </P>
        </div>
        <Link
          href={plansUrlWithUpgradeSource(upgradeSource, limitType)}
          target="_blank"
          className="mt-6 mb-1 sm:flex"
        >
          {" "}
          <Button tag="button" id="btn-viewplans" onClick={onViewPlans}>
            View Plans & Pricing
          </Button>
        </Link>
      </div>
    </Modal>
  );
}

export default UpgradeTeamPlanModal;
